const {PAGE_DATA_DATA_TYPES} = require('../dist/constants.json')
const {convertIdToAbsoluteUrn} = require('./convertIdToAbsoluteUrn')

/**
 *
 * @param {string} namespace
 * @returns {string}
 */
const convertNamespaceToAbsoluteUrn = namespace => convertIdToAbsoluteUrn(`${PAGE_DATA_DATA_TYPES[namespace]}.json`)

module.exports = {
    convertNamespaceToAbsoluteUrn
}
